import React from 'react';
import PropTypes from 'prop-types';
import { DialogTitle, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const TransactionDialogHeader = ({ title, subtitle, onClose }) => (
  <DialogTitle
    sx={{
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      gap: 2,
      pt: 3,
      pb: 3,
      px: 3,
      borderBottom: '1px solid #eeeeee'
    }}
  >
    <div>
      <Typography color="primary" variant="h2" sx={{ fontWeight: 400 }}>
        {title}
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: 'text.primary', mt: 0.5, maxWidth: 480 }}
      >
        {subtitle}
      </Typography>
    </div>
    <IconButton
      aria-label="Close"
      color="inherit"
      onClick={onClose}
      sx={{ width: 20, height: 20, mt: 0.5 }}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>
);

TransactionDialogHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
};

export default TransactionDialogHeader;
